import AiProviderLabel from './AiProviderLabel';

export default AiProviderLabel;
